// extracted by mini-css-extract-plugin
export default {"innerWrapper":"hr-z","tooltipWrapper":"ir-z","icon":"jr-z","tooltip":"kr-z","content":"lr-z"};